import { registrationAnalytics } from 'modules/registration/analytics';
import { ODIN_URLS, ROUTER } from 'src/constants';
import { sessionStore } from 'src/stores';
import { history, encodeQuery } from 'src/utils';
import { appEnvControl } from 'utils';

export const generateOnAuthHeader = () => {
  const query = encodeQuery.parseQuery(history.location.search);

  if (!query.invite_token) {
    return null;
  }

  return () => {
    if (sessionStore.isAuth) {
      history.push(ROUTER.PROFILE);
      return;
    }
    const redirectTo = `${window.location.origin}${window.location.pathname}${window.location.search}`;
    const authURL = `${ODIN_URLS[appEnvControl.currentEnvWithDefaultDev()]}/sign-in?redirectUri=${encodeURIComponent(redirectTo)}`;
    registrationAnalytics.authRedirect('sign-in');
    window.location.assign(authURL);
  };
};
